import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getUserInitials from '../../utils/getUserInitials';
import CropImageModal from '../../components/Modals/CropImageModal';
import { saveTempImage, getFullImageUrl } from '../../utils/api/services/image';

export class ProfileAvatar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: null,
    };
  }

  static propTypes = {
    user: PropTypes.object.isRequired,
    canEdit: PropTypes.bool,
  };

  static defaultProps = {
    canEdit: false,
  };

  handlePictureChange = (e) => {
    const file = e.target.files[0];
    e.target.value = ''; // сброс значения необходим для возможности повторно загрузить один и тот же файл
    if (!file || file.size === 0) {
      return;
    }

    const fr = new FileReader();
    fr.onload = () => {
      this.setState({
        popup: {
          file: fr.result,
        },
      });
    };

    fr.readAsDataURL(file);
  };

  closeCropPopup = () => {
    this.setState({ popup: null });
  };

  sendPhoto = (file) => {
    const self = this;
    saveTempImage(file)
      .then((result) => {
        self.props.setNewPicture(result.filename);
      })
      .catch((obj) => {
        alert('Не удалось загрузить изображение.');
      });
  };

  render() {
    const { firstName, lastName, picture } = this.props.user;
    const { newPicture } = this.props;
    const fullName = `${firstName} ${lastName}`;

    let pictureUrl = '';
    if (newPicture) {
      pictureUrl = newPicture;
    } else if (picture) {
      pictureUrl = getFullImageUrl(picture);
    }

    return (
      <div className="user-profile__block user-profile__avatar">
        {pictureUrl ? (
          <img className="user-profile__avatar-image" src={pictureUrl} alt={fullName} />
        ) : (
          <div className="user-profile__avatar-image user-profile__avatar-image--no-image">
            {getUserInitials(fullName)}
          </div>
        )}
        {this.props.canEdit && (
          <label
            htmlFor="avatar-input"
            className={classNames('button--circle', 'user-profile__avatar-button', {
              'user-profile__avatar-button--edit': picture,
              'user-profile__avatar-button--add': !picture,
            })}
          >
            <input
              id="avatar-input"
              type="file"
              name="file"
              className="visually-hidden"
              onChange={this.handlePictureChange}
              accept=".png, .jpeg, .jpg"
            />
          </label>
        )}
        {this.state.popup && (
          <CropImageModal
            fileSource={this.state.popup.file}
            sendPhoto={this.sendPhoto}
            close={this.closeCropPopup}
            ratio={1}
          />
        )}
      </div>
    );
  }
}
